import React, { useState, useEffect } from "react";
import UploadForm from "./UploadForm";
import {
  notarizeDocument,
  validateDocument,
} from "../../Services/notarizer.service";
import { NotificationManager } from "react-notifications";
import confirmDialog from "../Common/ConfirmDialog";

const UploadFile = () => {
  const [doc, setDoc] = useState([]);
  const [verifyDoc, setVerifyDoc] = useState([]);
  const [hash, setHash] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadingToValidate, setUploadingToValidate] = useState(false);
  const [kabutoExplorerUrl, setkabutoExplorerUrl] = useState("");

  const handleVerifyDoc = () => {
    let promise;
    if (hash !== "") {
      promise = validateDocument(hash, false);
    } else {
      promise = validateDocument(verifyDoc, true);
    }
    promise.then(
      ({ data }) => {
        NotificationManager.success(
          data && data.message ? data.message : "Your document is valid!",
          "You do it!",
          4000
        );
      },

      ({ data }) =>
        NotificationManager.error(
          data && data.message
            ? data.message
            : "The document could not be validated",
          "Something went wrong!",
          4000
        )
    );
  };

  const handleUploadFile = () => {
    confirmDialog().then((result) => {
      if (result.value) {
        setUploading(true);
        notarizeDocument(doc)
          .then(
            ({ data }) => {
              setkabutoExplorerUrl(data.kabutoExplorerUrl);
              NotificationManager.success(
                data && data.message
                  ? data.message
                  : "The action was completed successfully",
                "You do it!",
                4000
              );
            },

            ({ data }) =>
              NotificationManager.error(
                data && data.message
                  ? data.message
                  : "The action could not be completed",
                "Something went wrong!",
                4000
              )
          )
          .then(() => setUploading(false));
      }
    });
  };

  return (
    <div>
      <UploadForm
        style={{ background: "rgb(67, 97, 112,0.2)" }}
        uploading={uploading}
        setUploading={setUploading}
        file={doc}
        setFile={setDoc}
        onUploadFile={handleUploadFile}
        verify={false}
        title={"Notarize Document"}
        kabutoExplorerUrl={kabutoExplorerUrl}
      />
      <div style={{ marginBottom: 120 }}></div>
      <UploadForm
        uploading={uploadingToValidate}
        setUploading={setUploadingToValidate}
        style={{ background: "rgb(67, 97, 112,0.2)" }}
        file={verifyDoc}
        setFile={setVerifyDoc}
        onUploadFile={handleVerifyDoc}
        verify={true}
        title={"Verify Document"}
        setHash={setHash}
        hash={hash}
      />
      <div className="py-5" />
    </div>
  );
};

export default UploadFile;
